//#region Vars
import { createWebHistory, createRouter } from "vue-router";
import { nextTick } from 'vue';
//#endregion
//#region New
const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({
                        top: savedPosition.top,
                        left: savedPosition.left,
                    });
                }, 500);
            });
        }
        else {
            window.scrollTo(0, 0);
            return false;
        }
    },
    routes: [
        {
            name: "not-found",
            path: "/:catchAll(.*)",
            components: {
                default: {
                    template: '<g-error-page />'
                }
            },
            meta: {
                title: "Sorry",
                allowAnonymous: true,
                layout: "g-clean-layout"
            }
        }
    ],
});
router.openWindow = (address) => {
    // #region Check
    if (!address) {
        return;
    }
    let tCurrent = router.currentRoute?.value;
    {
        if (!tCurrent?.segments) {
            return;
        }
    }
    // #endregion
    // #region Vars
    let tSegements = [];
    //Load
    tCurrent.segments.items.forEach((s) => {
        tSegements.push(s.path);
    });
    // #endregion
    // #region String
    if (typeof address === "string") {
        if (address.startsWith('(') && tSegements.length > 0) {
            tSegements[tSegements.length - 1] += address;
        }
        else {
            tSegements.push(address);
        }
    }
    // #endregion
    // #region Address
    else {
        //Calculate        
        appHost.entities.calculateSegement(address);
        //Pust
        tSegements.push(address.path);
    }
    // #endregion
    // #region Push
    if (tSegements.length == 0) {
        return;
    }
    let tNew = {
        name: tCurrent.name,
        query: tCurrent.query,
        hash: tCurrent.hash,
        params: {
            segement: tSegements
        }
    };
    //Set
    {
        router.push(tNew);
    }
    // #endregion    
};
router.isModal = (component) => {
    return utils.findVueComponent(component, ["g-modal-popup", "g-modal-slide"]) !== null;
};
router.findRoute = (component) => {
    return router.findWindow(component);
};
router.findWindow = (component) => {
    let tRef = utils.findVueComponent(component, ["g-modal-popup", "g-modal-slide", "g-entity-page"]);
    {
        if (!tRef) {
            return undefined;
        }
    }
    return {
        segment: tRef.window,
        component: tRef,
        isClosable: tRef.window?.navigation?.isClosable ?? (tRef.$options.name === 'g-modal-popup' || tRef.$options.name === 'g-modal-slide')
    };
};
router.isClosable = (component) => {
    return router.findWindow(component)?.isClosable ?? false;
};
router.closeWindow = async (segment) => {
    // #region Check
    if (!segment || !segment.navigation) {
        return false;
    }
    if (!segment.navigation.isClosable) {
        return false;
    }
    // #endregion
    // #region Close
    let tCurrent = router.currentRoute.value;
    let tSegements = [];
    tCurrent.segments.items.forEach((s) => {
        if (s.index < segment.index) {
            tSegements.push(s.path);
        }
    });
    let tNew = {
        name: tCurrent.name,
        query: tCurrent.query,
        hash: tCurrent.hash,
        params: {
            segement: tSegements
        }
    };
    //Set
    {
        await router.push(tNew);
    }
    // #endregion
    return true;
};
router.closeCurrentWindow = async (component) => {
    return await router.closeWindow(router.findWindow(component)?.segment);
};
router.updateWindow = (data) => {
    // #region Vars
    let tCurrent = router.currentRoute.value;
    // #endregion
    // #region Calculate
    //appHost.entities.calculateSegement(segment);
    // #endregion
    // #region Set
    //tCurrent.segements.forEach(e => {
    //    if (e.index === segment.index) {
    //        e.path = segment.path;
    //    }
    //});
    //let tSegements: string[] = [];
    //tCurrent.segements.forEach(s => {
    //    tSegements.push(s.path);
    //});
    // #endregion
    // #region New
    //let tNew: any = {
    //    name: tCurrent.name,
    //    query: tCurrent.query,
    //    hash: tCurrent.hash,
    //    params: {
    //        segement: tSegements
    //    }
    //};
    //if (tSegements.length == 0) {
    //    return;
    //}
    ////Set
    //{
    //    router.push(tNew);
    //}
    // #endregion
    alert('TODO!!!!!');
};
router.beforeEach(async (to, from, next) => {
    // #region Old
    if (to.fullPath.startsWith('/#/')) {
        return next({
            path: to.fullPath.substr(2, to.fullPath.length - 2),
            hash: '',
            replace: true
        });
    }
    // #endregion
    // #region **Menu
    appHost.pageMeta.hideMobileNav();
    // #endregion
    // #region **Meta
    appHost.pageMeta.resetMeta();
    // #endregion
    // #region Logout
    if (to.name === "logout") {
        if (appHost.session.isAuthenticated) {
            await appHost.login.logout();
        }
        let tRoute = router.resolve({
            name: 'home',
        });
        if (tRoute?.meta?.allowAnonymous) {
            return next({
                name: 'home'
            });
        }
        else {
            return next({
                name: 'login'
            });
        }
    }
    // #endregion
    // #region Login
    if (to.name === "login" && appHost.session.isAuthenticated) {
        if (to.query?.returnUrl) {
            //Parse
            let tUrl = decodeURIComponent(to.query?.returnUrl);
            //Special
            if (tUrl.startsWith('/#')) {
                return next({ path: tUrl.substr(2), });
            }
            else {
                window.location.href = tUrl;
                return next();
            }
        }
        else {
            return next({ path: '/', });
        }
    }
    // #endregion
    // #region Event-Bus
    let tArgs = {
        to: to,
        from: from,
        next: next,
        cancel: false
    };
    //Run
    await appHost.eventBus.emit('router-beforeLeave', tArgs);
    //Cancel
    if (tArgs.cancel) {
        return;
    }
    // #endregion
    // #region Default
    if (to.meta.allowAnonymous !== undefined && to.meta.allowAnonymous) {
        return next();
    }
    if (!appHost.session.isAuthenticated) {
        return next({
            name: 'login',
            query: {
                returnUrl: to.fullPath === '/' ? undefined : encodeURIComponent((to.fullPath.startsWith('/') ? '' : '/') + to.fullPath)
            },
        });
    }
    // #endregion
    // #region redirect
    if (to.meta.redirect) {
        return next({
            path: to.meta.redirect,
            hash: '',
            replace: true
        });
    }
    // #endregion
    return next();
});
router.afterEach((to, from) => {
    if (to.meta.isSegementRoute) {
        //Set
        to.segments = appHost.entities.getEntityFromRoute(to);
        //Optimize
        if (to.segments.current?.navigation?.meta) {
            to.meta = { ...to.meta, ...to.segments.current?.navigation?.meta };
        }
    }
    //Metda
    if (!to.meta?.ignoreMeta) {
        nextTick(() => {
            //Breadrcumd
            if (to.meta?.breadcrumb) {
                appHost.store.commit('navigation/setBreadcrumb', to.meta?.breadcrumb);
            }
            //Title
            appHost.pageMeta.title = to.meta?.title;
            appHost.pageMeta.options = to.meta?.options;
        });
    }
});
// #endregion
export default router;
